import { ActionButton } from '@feedback/ui';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: #eceff1;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

const WarningCard = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

type Props = {
  domainName: string;
};
const DomainNotFound = ({ domainName }: Props) => {
  return (
    <Container>
      <WarningCard>
        <h3>Ops! O time</h3>
        <h1>{domainName}</h1>
        <h3>Não foi encontrado!</h3>
        <p>Você pode criar um time para a sua empresa:</p>
        <ActionButton href='https://feedback.house/join'>
          Criar Time
        </ActionButton>
      </WarningCard>
    </Container>
  );
};

export default DomainNotFound;
